import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Survey } from '@app/models/performance/survey.model';
import { NotifyService } from '@app/services';
import { saveAs } from 'file-saver';
import { convertToFilename } from '@app/functions/convert_to_filename';

@Injectable()
export class PerformanceExportService {
    constructor(
        private http: HttpClient,
        private notify: NotifyService
    ) {}

    exportSurvey(survey: Survey) {
        try {
            this.http
                .get('/v2/performanceManagement/surveys/' + survey.id + '/export', { responseType: 'blob' })
                .subscribe((exportData) => {
                    const filename = convertToFilename(survey.title);
                    saveAs(exportData, `${filename}.xlsx`);
                });
        } catch (err) {
            this.notify.error(err);
        }
    }
}
